/* eslint-disable no-useless-computed-key */
import { MenuItem, TextField, withStyles } from '@material-ui/core';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { Fragment, PureComponent } from 'react';

import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import Log from 'utilities/log';

import { GET_PENDING_AUTHS_FAILURE } from './store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getSubmittedTempFiles } from './store/actions/authorizations.actions';
import { fetchEnumerations } from './utils/fetchDataDetailsService';
import { Permissions } from 'modules/layout/permissions';
import { canSetPendingAuthCounselor, hasPermission } from 'modules/layout/permissionService';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import PendingAuthsGridComponent from './pendingAuthsGrid.component';
import SelectRcDialogComponent from './selectRcDialog.component';
import { getInternalUsers } from 'modules/common/common.actions';
import { getClients } from 'modules/clients/clients.actions';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';

const styles = theme => ({
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100
  }
});

class PendingAuths extends PureComponent {
  state = {
    showRcModal: false,
    authRecord: null,
    isInitialLoadComplete: false,
    selectedClientId: -1
  };

  async componentDidMount() {
    this.props.setPageTitle('Pending Auths');

    await fetchEnumerations(this.props);

    if (!this.props.pendingAuths) {
      let { type } = await this.props.getSubmittedTempFiles();
      if (type === GET_PENDING_AUTHS_FAILURE) {
        this.props.showToast('Failed to retrieve pending auths, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!Array.isArray(this.props.unmappedClients) || this.props.unmappedClients.length === 0) {
      await this.props.getClients();
    }

    if (!this.props.internalUsers) {
        await this.props.getInternalUsers();
    }

    // Mark initial load as complete after all data is loaded
    this.setState({ isInitialLoadComplete: true });
  }

  handleSummarySelect = id => {
    this.props.history.push(`/authorizations/${id}`);
  };

  onSelectReloCounselor = async record => {
    if (!canSetPendingAuthCounselor()) {
      return;
    }
    this.setState({ showRcModal: true, authRecord: record });
  };

  handleDeleted = async () => {
    this.setState({ showRcModal: false, authRecord: null });
  };

  render() {
    Log.trace('RENDER', 'ClientsView');
    const { history, isLoading, isLoadingClients, enumerations, unmappedClients, clientsInfo, pendingAuths } = this.props;
    const { showRcModal, authRecord, isInitialLoadComplete, selectedClientId } = this.state;

    if (!hasPermission(Permissions.File.Pending.Read)) {
      history.push('/');
      return null;
    }

    const canSetCounselor = canSetPendingAuthCounselor();
    const isGridLoading = !isInitialLoadComplete || isLoading || isLoadingClients;
    const filteredPendingAuths = pendingAuths
      ? pendingAuths.filter(auth => auth.clientRecordId === selectedClientId || selectedClientId === -1)
      : [];
    const sortedClients = unmappedClients ? unmappedClients.sort((a, b) => a.shortName.localeCompare(b.shortName)) : [];

    if (isGridLoading) return <FullscreenSpinner/>;

    return (
      <Fragment>
        <div className="px-2">
          <TextField
            select
            label="Clients"
            className={this.props.classes.textField}
            value={selectedClientId}
            onChange={event => this.setState({ selectedClientId: event.target.value })}
            SelectProps={{
              autoWidth: true,
            }}
            variant="outlined"
          >
            <MenuItem value={-1}>
              <em>All Clients</em>
            </MenuItem>
            {sortedClients.map(option => (
              <MenuItem key={option.clientRecordId} value={option.clientRecordId}>
                {option.shortName}
              </MenuItem>
            ))}
          </TextField>
          <PendingAuthsGridComponent
            authorizations={filteredPendingAuths}
            onSelect={this.handleSummarySelect}
            isLoading={isGridLoading}
            history={history}
            onSelectReloCounselor={this.onSelectReloCounselor}
            enumerations={enumerations}
            unmappedClients={unmappedClients}
            clientsInfo={clientsInfo}
            isReadOnly={!canSetCounselor}
          />
        </div>
        {showRcModal && (
          <SelectRcDialogComponent
            open={true}
            onCancel={() => this.setState({ showRcModal: false, authRecord: null })}
            authorization={authRecord}
            onSubmit={this.handleDeleted}
            disabled={!canSetCounselor}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    authorizations: { pendingAuthSummaries, pendingAuthSummariesLoading },
    enumerations,
    clients: { isLoading: isLoadingClients, unmappedClients, clientsInfo }
  } = state;
  return {
    pendingAuths: pendingAuthSummaries,
    isLoading: Boolean(pendingAuthSummariesLoading),
    isLoadingClients: Boolean(isLoadingClients),
    enumerations,
    unmappedClients,
    clientsInfo
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    getSubmittedTempFiles,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getClients,
    getInternalUsers
  })
)(PendingAuths);
